
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import {
  ACTION_ADD_TO_BAG,
  ACTION_ADD_TO_BAG_REMIX,
  ACTION_REMOVE_FROM_WISHLIST,
} from '@/scripts/store/actions'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  // TODO: move this inside header
  name: 'rb-base-wishlist',
  computed: {
    ...mapGetters(['translation']),
    ...mapState({
      loading: (state) => state.sidebar.wishlist.loading,
      items: (state) => state.sidebar.wishlist.items,
    }),
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    isEmpty() {
      return this.items.length <= 0
    },
    isCompareButtonEnabled() {
      return this.items.length > 1
    },
  },
  methods: {
    ...mapActions({
      dispatchAddToBag: ACTION_ADD_TO_BAG,
      dispatchAddToBagRemix: ACTION_ADD_TO_BAG_REMIX,
      dispatchRemoveFromWishlist: ACTION_REMOVE_FROM_WISHLIST,
    }),
    getPriceFromItem(item) {
      if (item.isRemix) {
        return item.price
      } else {
        return item.price ? item.price.list : null
      }
    },
    removeFromWishlist(item) {
      this.dispatchRemoveFromWishlist({
        wishlistItemId: item.catentryId,
        roxSet: item.roxSet,
        configurationId: item.configurationId,
      })
    },
    async addToBag(item) {
      this.dispatchRemoveFromWishlist({
        wishlistItemId: item.catentryId,
        roxSet: item.roxSet,
        configurationId: item.configurationId,
      })
      if (!item.isRemix) {
        this.dispatchAddToBag({
          catEntry: item.catentryId,
          isFromWishlist: true,
          configurationId: item.configurationId,
        })
      } else {
        this.dispatchAddToBagRemix({
          catEntry: item.catentryId,
          configurationId: item.configurationId,
          isFromWishlist: true,
        })
      }
    },
  },
}
